import { Component, HostListener, OnInit } from '@angular/core';
declare var $:any;

@Component({
  selector: 'app-club',
  templateUrl: './club.component.html',
  styleUrls: ['./club.component.scss']
})
export class ClubComponent implements OnInit {
  pdfSrc: string[] = [
    '/assets/pdf/eco club.pdf',
    '/assets/pdf/eco.pdf',
  ];
  src: string;
  isLoading = true;
  showPdf:boolean;
  ngOnInit(): void {
    this.changeRoute('2025-26');
  }

  changeRoute(year: string) {
    this.isLoading = true;
    
    if (year == '2025-26') {
      $('.second').removeClass('active');
      $('.first').addClass('active');
      this.src = this.pdfSrc[0]
      this.showPdf=true;
    }
    if (year == '2023-24') {
      $('.first').removeClass('active');
      $('.second').addClass('active');
      this.src = this.pdfSrc[1]
      this.showPdf=false;
    }
  }
  hideLoader() {
    this.isLoading = false;
  }
  
}
//   @HostListener("click") onClick(){
//     this.checkRoute();
//   }
//   fullWidth=false;
//   showSideMenu = true;
//   constructor() { }

//   ngOnInit(): void {
//     this.checkRoute();
//   }

//   splitUrl(){
//     let url=location.pathname.split('/');
//     // console.log(url);
//     if(url.length === 3){
//       this.showSideMenu=true;
//       this.fullWidth=false;
//     }
//     else if(url.length === 4 && (url[3]=== '2022-23') ){
//       this.showSideMenu=false;
//       this.fullWidth=true;
//     }
//   }
//   checkRoute(){
//     setTimeout(()=>{
//       this.splitUrl();
//     })
//   }
// }
